export default {
  currency: 0,
  typeChange: "mxn",
};
